const FAQ_ITEMS = [
  {
    q: '91精品影视是否需要注册或付费？',
    a: '完全不需要。91精品影视所有资源均可免费观看，无需注册账号，无需支付任何费用。我们致力于为广大影迷提供真正的91影视看片免费体验，打开网站即可直接观影。',
  },
  {
    q: '为什么91精品影视看片不缓冲、不卡顿？',
    a: '91精品影视采用全球CDN加速网络与智能自适应缓冲技术，根据您的网络环境自动匹配最佳画质。同时我们使用高性能服务器集群，确保即使在高峰时段也能保持91影视高清免费不缓冲的流畅体验。',
  },
  {
    q: '可以在手机上使用91精品影视吗？',
    a: '当然可以。91精品影视全面适配手机、平板等移动设备，无需下载任何APP，通过手机浏览器即可畅享高清在线看片。页面自适应不同屏幕尺寸，操作便捷流畅。',
  },
  {
    q: '91精品影视的资源更新频率如何？',
    a: '我们每天持续更新资源库，热门电影、电视剧、综艺和动漫均会在第一时间上线高清版本。首页"最新更新"板块实时展示最新的资源动态，确保您不错过任何精彩内容。',
  },
  {
    q: '观看时遇到问题怎么办？',
    a: '如果您在使用91影视在线看片过程中遇到任何播放问题，可以通过"联系我们"板块发送邮件反馈。我们的技术团队会尽快排查并解决问题，持续优化大家的在线看片体验。',
  },
];

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">常见问题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            您可能关心的一些问题，这里都有答案
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-200/70 border border-background-300/30 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/15 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-400">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-100">{item.q}</h3>
                    <div className="mt-3 pt-3 border-t border-background-300/20">
                      <div className="flex items-start gap-2">
                        <span className="text-xs font-bold text-accent-400 flex-shrink-0">A</span>
                        <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">{item.a}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}